// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"style_breadcrumb__mf4ER","item":"style_item__zcYDx","active":"style_active__yLmuP"};